<template>
  <div class="panel-body">
    <div class="text-size-20">
      ACROSS倉庫から出荷することでSTOCKCREW倉庫へ納品できます。 <br><br>
      以下のメニューよりお手続きください。<br>
      倉庫管理TOP > ACROSS倉庫 > 出荷 > STOCKCREW倉庫へ出荷 <br> <br>
      <button class="btn btn-primary bd-rds-8 text-size-22 pd-t-10 pd-b-10 pd-r-35 pd-l-35 mr-t-10" @click="$router.push('/warehouses')">
        倉庫管理TOPはコチラ
        <i class="fa fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>

<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  mounted () {
    let logParams = {
      name: eventCode.warehouse_sc.delivery_tab.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouseSc/DeliveryStatusInquiry.vue